import imageHolder from './imageHolder'
import animatedItem from './animatedItem'
import avatarItem from './avatarItem'
import text from './text'
import videoItem from './videoItem'

const assetTypeToLibraryItemMapping = {
  imageHolder,
  avatar: avatarItem
}

const itemTypeToLibraryItemMapping = {
  movieClip: animatedItem,
  text,
  spine: animatedItem,
  fyber: animatedItem,
  video: videoItem
}

export default function typeProps(libraryItem, options) {
  const mappingFunction = (
    assetTypeToLibraryItemMapping[libraryItem.assetType] ||
    itemTypeToLibraryItemMapping[libraryItem.itemType]
  )

  return mappingFunction ? mappingFunction(libraryItem, options) : {}
}
